import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import CurtainOverlay from "./components/CurtainOverlay";
import Snackbar from "./components/Snackbar";
import ApiLoader from "./components/ApiLoader";
import ScrollToTop from "./scrollTopView";
import PlanDetails from "./page/PlanDetails";
import PlanPage from "./page/PlanPage";
import Contact from "./page/Contact";
import AboutUs from "./page/AboutUs";
import MagmaPremiumCarePlan from "./page/MagmaPremiumCarePlan";
import PrivacyPolicy from "./page/TermAndPolicy/PrivacyPolicy";
import ShippingDelivery from "./page/TermAndPolicy/ShippingDelivery";
import Cancellation from "./page/TermAndPolicy/Cancellation";
import HomePage from "./page/HomePage";
import TermofUse from "./page/TermAndPolicy/TermofUse";
import { setTheme } from "./utils/helper";
import PaymentDetails from "./page/PlanPurchase/PaymentDetails";
import SuccessPay from "./page/SuccessPay";
import MainRoute from "./MainRoute";
import MagmaHealthShieldPlan from "./page/MagmaHealthShieldPlan";
import MagmaAdvantage from "./page/MagmaAdvantage";
import MagmaPrime from "./page/MagmaPrime";
import MagmaHealthShieldPlusPlan from "./page/MagmaHealthShieldPlusPlan";

function App() {
  const [showCurtain, setShowCurtain] = useState(false);
  const [readyToShowSite, setReadyToShowSite] = useState(false);
  const launchDate = new Date("2025-06-11T10:00:00+05:30").getTime();

  useEffect(() => {
    setTheme({
      text: "#ffffff",
      btnText: "#ffffff",
      cardGrad1: "#114a52",
      cardGrad2: "#e0e94c",
      policyHide: false,
    });

    const seen = localStorage.getItem("launchSeen");

    if (!seen && Date.now() < launchDate) {
      // Show curtain first
      setShowCurtain(true);
    } else {
      // If already seen or after launch, show site
      setReadyToShowSite(true);
    }
  }, [launchDate]);

  const handleCurtainComplete = () => {
    localStorage.setItem("launchSeen", "true");
    setShowCurtain(false);
    setReadyToShowSite(true);
  };

  return (
    <>
      {showCurtain && (
        <CurtainOverlay
          launchDate={launchDate}
          onComplete={handleCurtainComplete}
        />
      )}

      {readyToShowSite && (
        <>
          <Snackbar />
          <ApiLoader />
          <ScrollToTop />
          <Routes>
            <Route element={<MainRoute />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/cancellation-policy" element={<Cancellation />} />
              <Route path="/term-of-use" element={<TermofUse />} />
              <Route
                path="/shipping-delivery-policy"
                element={<ShippingDelivery />}
              />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/magmapremiumcare" element={<MagmaPremiumCarePlan />} />
              <Route path="/magmaadvantage" element={<MagmaAdvantage />} />
              <Route path="/magmaprime" element={<MagmaPrime />} />
              <Route path="/magmahealthshield" element={<MagmaHealthShieldPlan />} />
              <Route path="/magmahealthshieldplus" element={<MagmaHealthShieldPlusPlan />} />
              <Route path="/plans" element={<PlanPage />} />
              <Route path="/opd-payments" element={<PlanDetails />} />
              <Route path="/opd-payments.html" element={<PlanDetails />} />
              <Route path="/payment" element={<SuccessPay />} />
            </Route>
            <Route
              path="/plan-purchase/payment-detail"
              element={<PaymentDetails />}
            />
          </Routes>
        </>
      )}
    </>
  );
}

export default App;
